module.exports = __webpack_public_path__ + "static/img/02.776be178.jpg";